// extracted by mini-css-extract-plugin
module.exports = {"root":"SearchBar-module_root_27rFZ","input":"SearchBar-module_input_7tmzF"};